import { apiService } from '../../../services/apiService';
import { API_PATHS } from '../../../utils/apiPaths';
import { createCompleteGridFetcher } from '../../../utils/fetchCompleteGridList';
import type { AuditLogListRequest } from '../models/types';
import { buildAuditLogRequest, mapAuditLogRow } from '../utils/utils';

export async function fetchAuditLogList(payload: AuditLogListRequest) {
  const res: any = await apiService.post(API_PATHS.GET_AUDIT_LOGS, payload);
  if (!res?.success) {
    throw new Error(res?.message || 'Failed to load audit logs.');
  }

  const payloadData = res.data ?? {};
  const list = Array.isArray(payloadData)
    ? payloadData
    : Array.isArray(payloadData.content)
      ? payloadData.content
      : [];
  const pageMeta =
    payloadData.page && typeof payloadData.page === 'object' ? payloadData.page : null;
  const reportedTotal = payloadData.totalElements ?? pageMeta?.totalElements;
  const totalElements = Number(reportedTotal ?? list.length);

  return {
    rows: list.map((item: Record<string, unknown>) => mapAuditLogRow(item)),
    totalElements: Number.isFinite(totalElements) ? totalElements : list.length,
  };
}

export const fetchAuditLogGrid = createCompleteGridFetcher((
  options: Parameters<typeof buildAuditLogRequest>[0],
) => fetchAuditLogList(buildAuditLogRequest(options)));
